import TableRow from "@mui/material/TableRow";
import { useContext } from "react";
import { Material } from "../../../../data/entities";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";

import { ROLE } from "../../../../data/enums";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import Status from "../../../../shared/components/Status";
import { StyledNavLinkNewTab } from "../../../../shared/styled/TableStyles";
import { formatNumber } from "../../../../utils/format";

const getStatusColorTheme = (item: Material) => {
    if ((item.available_quantity ?? item.quantity) >= item.threshold) {
        return "SUCCESS";
    }
    return "FAIL";
};

const getStatusText = (item: Material) => {
    if ((item.available_quantity ?? item.quantity) >= item.threshold) {
        return "TRÊN MỨC";
    }
    return "DƯỚI MỨC";
};

interface MaterialRowProps {
    item: Material;
}

export const MaterialRow = ({ item }: MaterialRowProps) => {
    
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    
    return (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLinkNewTab 
                    href={`/materials/${item.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {item.material_code ? item.material_code : item.id}
                </StyledNavLinkNewTab>
            </StyledTableCell>
            <StyledTableCell align="left">{item.name}</StyledTableCell>
            <StyledTableCell align="left">{formatNumber(item.quantity)}</StyledTableCell>
            <StyledTableCell align="left">{formatNumber(item.locked_quantity ?? 0)}</StyledTableCell>
            <StyledTableCell align="left">
                {formatNumber(item.available_quantity ?? item.quantity)}
            </StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={getStatusColorTheme(item)}
                    text={getStatusText(item)}
                    width="73px"
                />
            </StyledTableCell>
            { (role !== ROLE.FIRST_STORAGE_KEEPER && role !== ROLE.SECOND_STORAGE_KEEPER) && (
                <StyledTableCell align="left">
                    {item.storage}
                </StyledTableCell>
            )}
            <StyledTableCell align="left">
                {item.measurement_unit}
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.secondary_measurement_unit}
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.conversion_rate}
            </StyledTableCell>
            <StyledTableCell align="left">{item.note}</StyledTableCell>
            {/* <StyledTableCell align="left">
                {formatDate(new Date(item.expired_date))}
            </StyledTableCell> */}
        </TableRow>
    );
};
